import React, { Component, useEffect, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Paper from "@material-ui/core/Paper";
import "../workflow/workflow.css";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Tooltip from "@material-ui/core/Tooltip";
import MiddleHeader from "../middleHeader/middleHeader";
import Typography from "@material-ui/core/Typography";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import RootRef from "@material-ui/core/RootRef";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Checkbox from "@material-ui/core/Checkbox";
import Modal from "./modal";
import hierarchy from "../../Assets/hierarchy.png";
import companyG from "../../Assets/Company_icon.png";
import drag from "../../Assets/drag.png";
import help from '../../Assets/help_icon.png';
import helpAr from '../../Assets/help_icon_ar.png';
import Action from "./actions";
import HeirarchyUser from "./addUserHierarchy";
import { List, ListItemIcon, Grid, IconButton } from "@material-ui/core";
import useStyles from "./workflowStyle";
import Colors from "./../../Global/colors";
import Spinner from "./../../Global/Spinner2";
import NoRecords from "./../../Global/NoRecords";
import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import { useSelector, useDispatch } from "react-redux";
import { addCompany } from "../../Redux/Actions/companyAction";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useTranslation } from "react-i18next";

const Hierarchy = ({isOnboarding=false}) => {
  const {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  const [roles, setRoles] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [sitesLoader, setSitesLoader] = useState(true);
  const [hierarchyLoader, setHierarchyLoader] = useState(true);
  const [usedRoles, setUsedRoles] = useState([]);
  const [filledRoles, setFilledRoles] = useState([]);
  const [newArr, setNewArr] = useState([]);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [currentEditObj, setCurrentEditObj] = useState({});
  const [userData, setUserData] = useState([]);
  const [users, setUsers] = useState([]);
  const [sites, setSites] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false);
  const [userSites, setUserSites] = useState([]);
  const [token, setToken] = useState("");
  const [selectedCompany, setSelectedCompany] = useState({});
  const [selectedRole, setSelectedRole] = useState("");
  const [update, setUpdate] = useState(false);
  const [change, setChange] = useState(true);
  const [modal, setModal] = useState(false);
  const [editRole, setEditRole] = useState(false);
  const [currentRole, setCurrentRole] = useState({});
  const [currentCompany, setCurrentCompany] = React.useState([]);
  const [companies, setCompanies] = React.useState([]);
  const [currentCompanyName, setCurrentCompanyName] = React.useState("");
  const dispatch = useDispatch();
  const classes = useStyles();

  let data1 = useSelector((state) => state.companyArrReducer.company);

  useEffect(
    () => {
      if (data1) {
        setCompanies(data1);
      }
    },
    [data1]
  );

  console.log("selectedRole>>>>>>>>>>>>>", selectedRole);
  let data2 = useSelector((state) => state.userReducer.user);

  useEffect(
    () => {
      setUserData(data2);
      setToken(data2.token);
    },
    [data2]
  );

  let data = useSelector((state) => state.companyReducer.company);
  useEffect(
    () => {
      setChange(false);
      setSelectedCompany(data);
      setCurrentCompany(data);
      setCurrentCompanyName(data.id);
      getHierarchy(data);
      getAllHierarchyOrganizations(data);
      getTeamsAndSites(data);
    },
    [data]
  );

  const handleCompanyChange = (value) => {
    console.log(value.target.value);
    const index = companies.findIndex((item) => item.id === value.target.value);
    console.log(index);
    console.log("value", companies[index]);
    dispatch(addCompany(companies[index]));
    setCurrentCompanyName(companies[index].id);
  };

  const editTier = async (Arr, index) => {
    let arr = newArr;
    let hieObj = Arr[index];
    setSelectedRole(hieObj.id);
    console.log(arr);
    console.log(hieObj);
    setCurrentEditObj(hieObj);
    await setEditMode(true);

    let temp_arr = [];
    let HierarchyOrganizations = hieObj.HierarchyOrganizations;
    let HierarchyUsers = HierarchyOrganizations.HierarchyUsers;
    for (let iterator3 of HierarchyUsers) {
      let sitesArr = [];
      let HierarchySites = iterator3.HierarchySites;
      for (let iterator4 of HierarchySites) {
        sitesArr.push(iterator4.site_id);
      }

      let flag = false;
      for (let chkIt of temp_arr) {
        if (chkIt.id == iterator3.id) {
          flag = true;
        }
      }
      if (flag == false) {
        let obj = {
          id: iterator3.id,
          user_id: iterator3.id,
          first_name: iterator3.first_name,
          last_name: iterator3.last_name,
          checked: false,
          sites: sitesArr,
        };
        temp_arr.push(obj);
      }
    }

    let final_arr = [];
    for (let iterator of arr) {
      let user_checked = false;
      let site_arr = [];
      let user_id = iterator.user_id;
      let all_sites = iterator.sites;
      for (let iterator2 of temp_arr) {
        let temp_user_id = iterator2.id;
        if (user_id == temp_user_id) {
          user_checked = true;
          let temp_sites = iterator2.sites;
          for (let iterator3 of all_sites) {
            let flag2 = false;
            for (let iterator4 of temp_sites) {
              if (iterator4 == iterator3.site_id) {
                flag2 = true;
              }
            }
            let obj2 = {
              site_id: iterator3.site_id,
              title: iterator3.title,
              checked: flag2,
            };
            site_arr.push(obj2);
          }
        }
      }

      if (user_checked == true) {
        let obj = {
          user_id: iterator.user_id,
          firstName: iterator.firstName,
          lastName: iterator.lastName,
          checked: user_checked,
          sites: site_arr,
        };
        final_arr.push(obj);
      } else {
        let obj = {
          user_id: iterator.user_id,
          firstName: iterator.firstName,
          lastName: iterator.lastName,
          checked: user_checked,
          sites: iterator.sites,
        };
        final_arr.push(obj);
      }
    }
    setNewArr(final_arr);

    console.log("finala ARR>>>>>>>>>>>", final_arr);
  };

  const onCheckUser = (value, index) => {
    let _newArr = [...newArr];
    _newArr[index].checked = value;
    setNewArr(_newArr);
  };

  const onCheckSite = (value, index, subIndex) => {
    let _newArr = [...newArr];
    _newArr[index].sites[subIndex].checked = value;
    setNewArr(_newArr);
  };

  const cancelEdit = () => {
    setSitesLoader(true)
    getTeamsAndSites(selectedCompany);
    setEditMode(false);
    setSelectedRole("");
    setEditRole(false)
  };

  const deleteRole = () =>{
        let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);


    let params = { hierarchy_id: selectedRole,company_id:selectedCompany.id };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Hierarchy/delete_hierarchy?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from Delete Api>>>>>>>>>>>", response);
        if(response.msg == "success"){
          getHierarchy(currentCompany)
          setSelectedRole("")
          swal(t("Success"), t("Selected Role Deleted Successfully"), "success");
        }
      })
      .catch((error) => console.log(error));

  }

  const getTeamsAndSites = (currentCompany) => {
    setSitesLoader(true);
    console.log("currentCompany", currentCompany);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);

    let token = data.token;
    console.log("Token", token);

    let params = { company_id: currentCompany.id };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/HierarchyOrganization/get_team_with_sites?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from New Api>>>>>>>>>>>", response);
        setNewArr(response.data);
        setSitesLoader(false);
      })
      .catch((error) => console.log(error));
  };

  const getHierarchy = (currentCompany) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany.id,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Hierarchy/get_all_hierarchys?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("RESPONSE FROM GET ALL HIRARCHEYS", response);
        if (response.status === "Success") {
          // console.log(response);
          await setRoles(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getHierarchy(currentCompany);
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const getAllHierarchyOrganizations = (currentCompany) => {
    setHierarchyLoader(true);
    let localstorage = localStorage.getItem("UserData");

    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = { company_id: currentCompany.id };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(
      GlobalApi +
        "/HierarchyOrganization/get_all_hierarchy_organizations?" +
        query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg == "success") {
          console.log("All HIRARCHY ORGANIZATIONS>>>>>>>>>>>>>>>>>>", response);

          let _usedRoles = [];
          if (response.data.length > 0) {
            response.data.forEach((item) => {
              console.log("item in hirarchy organization", item);
              let obj = {
                ...item,
                hierarchy_organization_id: item.HierarchyOrganizations.id,
                position: parseInt(item.HierarchyOrganizations.position),
              };
              _usedRoles.push(obj);
            });

            console.log("used Roles after push>>>>>>>>", _usedRoles);
            setUsedRoles(_usedRoles);
            setFilledRoles(_usedRoles);

            setUpdate(true);
            setChange(true);
            setHierarchyLoader(false);
          } else {
            setUsedRoles(response.data);
            setChange(true);
          }

          setChange(true);
          setHierarchyLoader(false);
        }
      })
      .catch((error) => {
        console.log("error.message", error);
        setHierarchyLoader(false);
      });
  };

  const addTier = async () => {
    setBtnLoader(true);

    let selectedUser = false;
    let selectedSite = false;

    console.log(newArr)

    // newArr.forEach((item) => {
    //   if (item.checked == true) {
    //     selectedUser = true;
    //     item.sites.forEach((v) => { 
    //       if (v.checked == true) selectedSite = true;
    //     });
    //   }
    // });

    if(!editMode && selectedRole == ""){
      swal(t("Error"), t("Select A User Role"), "error");
      setBtnLoader(false);
    }
    newArr.forEach((item)=>{
      if(item.checked == true){
        selectedUser = true;
        item.sites.forEach((v)=>{
          if (v.checked == true)selectedSite = true;
        })
      }
    })
    if (selectedUser == false) {
      swal(t("Error"), t("Atleast One User Required"), "error");
      setBtnLoader(false);
    } else if (selectedUser == true) {
      if (selectedSite == false){
        swal(t("Error"), t("Atleast One Site Required For Each User"), "error");
        setBtnLoader(false);
        }
      else if (selectedSite == true) {
        let localstorage = localStorage.getItem("UserData");

        var data = JSON.parse(localstorage);
        let token = data.token;

        
        if (!editMode && selectedRole !== "") {
          var list = [...roles];
          var used = [...usedRoles];
          var available = [...availableRoles];
          var index = await list.findIndex((x) => x.id == selectedRole);

          if (list[index] == undefined) {
            return;
          }

          let abcd = [];
          for (const iterator of newArr) {
            if (iterator.checked == true) {
              abcd.push(iterator);
            }
          }

          let finalArr = [];
          for (const iterator2 of abcd) {
            let fetchP = iterator2.sites;
            let mySites = [];
            for (const iterator3 of fetchP) {
              if (iterator3.checked == true) {
                mySites.push(iterator3.site_id);
              }
            }
            let obj = { user_id: iterator2.user_id, sites: mySites };
            finalArr.push(obj);
          }

          console.log("Final Arr im sending >>>>>>>>", finalArr);
          var item = {
            title: list[index].title,
            heirarchy_id: selectedRole,
            color: list[index].color,
            position: (used?.length + 1).toString(),
            status: "active",
            company_id: selectedCompany.id,
            identifier: "Local",
            created_by: selectedCompany.id,
            users: finalArr,
          };

          fetch(
            GlobalApi + "/HierarchyOrganization/create_hierarchy_organization",
            {
              method: "post",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
              body: JSON.stringify(item),
            }
          )
            .then((response) => response.json())
            .then((res) => {
              console.log("res>>>>>>>>>>>>>>>>>>>>>", res)
              if (res.status === "success") {
                swal(t("Success"), t("Hierarchy has been created successfully"), "success");
                setSelectedRole("")
                setBtnLoader(false);
                console.log(res.data);
                getAllHierarchyOrganizations(selectedCompany);
                getTeamsAndSites(selectedCompany);
              }
            });
        }
        if (editMode) {
          console.log("Edit Mode Called");
          let abcd = [];
          for (const iterator of newArr) {
            if (iterator.checked == true) {
              abcd.push(iterator);
            }
          }

          let finalArr = [];
          for (const iterator2 of abcd) {
            let fetchP = iterator2.sites;
            let mySites = [];
            for (const iterator3 of fetchP) {
              if (iterator3.checked == true) {
                mySites.push(iterator3.site_id);
              }
            }
            let obj = { user_id: iterator2.user_id, sites: mySites };
            finalArr.push(obj);
          }

          console.log("Final Arr im sending >>>>>>>>", finalArr);
          console.log(
            "setCurrentEditObj>>>>>",
            currentEditObj.hierarchy_organization_id
          );

          var item = {
            hierarchy_organization_id: currentEditObj.hierarchy_organization_id,
            users: finalArr,
          };

          fetch(
            GlobalApi + "/HierarchyOrganization/edit_hierarchy_organization",
            {
              method: "post",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
              body: JSON.stringify(item),
            }
          )
            .then((response) => response.json())
            .then((res) => {
              console.log("res?>>>>>>>", res);

              if (res.msg === "success") {
                swal(t("Success"), t("Hierarchy has been updated successfully"), "success");
                getAllHierarchyOrganizations(selectedCompany);
                getTeamsAndSites(selectedCompany);
                setBtnLoader(false);
                setEditMode(false);
              }
            });
        }
      }
    }
  };

  const handleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const deleteTier = async (id) => {
    console.log("deleteTier", id);
    var used = [...usedRoles];
    var index = await used.findIndex(
      (x) => x?.HierarchyOrganizations?.id == id
    );

    let localstorage = localStorage.getItem("UserData");

    var data = JSON.parse(localstorage);
    let token = data.token;
    let deleteTierRequest = await fetch(
      GlobalApi + "/HierarchyOrganization/delete_hierarchy_organization",
      {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({ hierarchy_organization_id: id }),
      }
    );

    let reqJson = await deleteTierRequest.json();
    if (reqJson.status === "Success") {
      console.log("tier Deleted");
      used.splice(index, 1);
      used.map(async (v, i) => {
        let pos = i + 1;
        let req = await fetch(
          GlobalApi + "/HierarchyOrganization/edit_hierarchy_organization_position",
          {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              position: pos.toString(),
              hierarchy_organization_id: v?.HierarchyOrganizations?.id,
            }),
          }
        );

        let reqJson_2 = await req.json();

        if (used?.length - 1 === i) {
          getAllHierarchyOrganizations(selectedCompany);
          getTeamsAndSites(selectedCompany);
          setEditMode(false);
          swal(t("Success"), t("Deleted Successfully"), "success");
        }
      });
      getAllHierarchyOrganizations(selectedCompany);
    }
  };

  const openModal = async (type) => {
    
    if(type == "edit"){
      setCurrentRole(roles.filter(item=>item.id == selectedRole)[0])
 setEditRole(true)
 setModal(true);
      
    }else{
      setCurrentRole({})
      setEditRole(false)
      setModal(true);
    }
  };

  const handleCancel = () =>{
    setSelectedRole("")
  }

  const closeModal = () => {
    setModal(false);
  };

  const addNewHierarchy = async (hierarchy) => {
    console.log("hierarchy>>>>>>>>>>>>>>>>>>", hierarchy);

    var _roles = [...roles];
    var item = {
      // id: hierarchy.id,
      title: hierarchy.title,
      color: hierarchy.color,
      position: _roles.length + 1,
      company_id: selectedCompany.id,
      identifier: "Local",
      created_by: data.organization_id,
    };
    fetch(GlobalApi + "/Hierarchy/create_hierarchy", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(item),
    })
      .then((response) => response.json())
      .then((res) => {
        console.log("create Hirarchy>>>>>>>>>>>>>>>>>>", res);
        if (res.status === "Success") {
          _roles.push(res.data);
          setRoles(_roles);
          swal(t("Success"), t("User Role Created Successfully"), "success");
        }
      });
  };

  

  const editHierarchy = async (hierarchy) => {
    console.log("hierarchy>>>>>>>>>>>>>>>>>>", hierarchy);


    fetch(GlobalApi + "/Hierarchy/edit_hierarchy", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(hierarchy),
    })
      .then((response) => response.json())
      .then((res) => {
        console.log("edit Hirarchy>>>>>>>>>>>>>>>>>>", res);
        if (res.status === "Success") {
          getHierarchy(selectedCompany)
          setSelectedRole("")
          swal(t("Success"), t("User Role Updated Successfully"), "success");
        }
      });
  };

  return <>
      <div className={isOnboarding == true ? "scrollHidden" : ""} style={{ width: "100%", minHeight: "90vh", padding:isOnboarding == true ? (window.innerWidth > 500 ? "20px 1px 20px 20px" : "10px 1px 10px 10px") : "20px", overflowY: "scroll", backgroundColor: Colors.globalColor9 }}>
        <Grid container justifyContent="center" alignItems="flex-start" spacing={2}>
          <Grid item xs={12} md={12} lg={6}>
            <Grid container className="shadow" alignItems="center" style={{ padding: 0, borderWidth: "1px", borderStyle: "solid", borderColor: Colors.globalColor4, borderRadius: "10px", backgroundColor: "white" }}>
              <Grid item xs={12} md={12} lg={12} style={{ padding: "5px 20px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Colors.globalColor4 }}>
                <p className="label2" style={{ marginBottom: 5, marginTop: 5, color: Colors.globalColor8 }}>
                  1. {t("Select Company")}
                </p>
              </Grid>
              <Grid item xs={12} md={12} lg={12} spacing={3} style={{ padding: "5px 10px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Colors.globalColor4 }}>
                <Grid container alignItems="center" xs={12}>
                  {/* <Grid item >
              <div style={{minWidth:'100px', textAlign:'center'}}>
              <p style={{ display: "inline", color: Colors.globalColor8, textTransform: "uppercase", fontSize: 12, fontWeight: "bold" }} className="UserName">
                {"COMPANY : "}
              </p>
              </div>
            </Grid>
            <Grid item >
              <FormControl>
                <Select className="SelectBox"// id="demo-simple-select"
                  style={{ minWidth: 300 }} value={selectedCompany.company_name} onChange={(e)=>handleCompanyChange(e.target.value)} variant="outlined" size="small">
                  {companies.map((item) => {
                    return <MenuItem value={item.id}>
                        {item.company_name}
                      </MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid> */}

                  <Grid item xs={0} sm={2} lg={2}>
                  {window.innerWidth > 500 && <div style={{ cursor: "pointer",  textAlign: "center" }}>
                      <IconButton>
                        <img src={companyG} alt={""} width="30px" />
                      </IconButton>
                    </div>}
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6} >
                    <FormControl style={{width:'100%'}}>
                      <Select className="SelectBox" style={{ width: "100%", backgroundColor: "#f7f9fb" } // id="demo-simple-select"
                        } value={currentCompanyName} onChange={(value) => handleCompanyChange(value)} variant="outlined" size="small">
                        {companies.map((item, index) => {
                          return <MenuItem value={item.id}>
                              {item.company_name}
                            </MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={12} lg={12} style={{ padding: "5px 20px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Colors.globalColor4 }}>
                <p className="label2" style={{ marginBottom: 5, marginTop: 5, color: Colors.globalColor8 }}>
                  2. {t("Create User Role")}
                </p>
              </Grid>
              <Grid item xs={12} md={12} lg={12} spacing={1} style={{ padding: "5px 10px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Colors.globalColor4 }}>
                <Grid container alignItems="center">
                  {window.innerWidth > 500 && <Grid item xs={0} sm={2} lg={2} >
                    <div style={{ cursor: "pointer", textAlign: "center" }}>
                      <IconButton>
                        <img src={hierarchy} alt={""} width="35px" />
                      </IconButton>
                    </div>
                  </Grid>}
                  <Grid item xs={12} sm={6} lg={6} >
                    <FormControl style={{width:'100%'}}>
                      <Select className="SelectBox" style={{width:'100%', backgroundColor: "#f7f9fb" } // id="demo-simple-select"
                        } value={selectedRole} onChange={handleChange} variant="outlined" size="small">
                        {roles.length > 0 ? roles.map((role) => {
                            if (!editMode && usedRoles.findIndex((x) => x.id == role.id) <= -1) {
                              console.log("sajkdhajkdhjashdjkasdhjadhjadg", usedRoles.findIndex((x) => x.id == role.id));
                              return <MenuItem value={role.id}>
                                  {role.title}
                                </MenuItem>;
                            }
                          }) : <div style={{ paddding: "10px" }}>
                            <p>{t("No Roles Avaliable")}</p>
                          </div>}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4} lg={4} >
                  {selectedRole == "" ?  <div  style={{ textAlign: "center",}}>
                      {" "}
                      {window.innerWidth > 500 ? <Tooltip title={t("Add New Hierarchy")}>
                        <Button variant="contained" type="submit" className="addBtn" style={{margin:'0px 10px' }} component="span" onClick={()=>openModal("add")}>
                          {t("Add New Role")}
                        </Button>
                      </Tooltip> : <Tooltip title={t("Add New Hierarchy")}>
                        <Button variant="contained" type="submit" className="addBtn" style={{width:'100%', marginTop:10}} component="span" onClick={()=>openModal("add")}>
                          {t("Add New Role")}
                        </Button>
                      </Tooltip>}
                    </div> :
                     <div  style={{ textAlign: "center",}}>
                      {" "}
                      {window.innerWidth > 500 ? <><Tooltip title="Edit Hierarchy">
                        <Button variant="contained" type="submit" className="addBtn" style={{margin:'0px 5px' }} component="span" onClick={()=>openModal("edit")}>
                          {t("Edit")}
                        </Button>
                      </Tooltip><Tooltip title="Delete Hierarchy">

                        <Button variant="contained" type="submit" className="deleteBtn" style={{margin:'0px 5px' }} component="span" onClick={()=>deleteRole()}>
                          {t("Delete")}
                        </Button>
                      </Tooltip>
                   </> : <><Tooltip title="Edit Hierarchy">
                        <Button variant="contained" type="submit" className="addBtn" style={{width:'100%', marginTop:10}} component="span" onClick={()=>openModal("edit")}>
                          {"Edit"}
                        </Button>
                      </Tooltip>
                      <Tooltip title="Delete Hierarchy">
                        <Button variant="contained" type="submit" className="deleteBtn" style={{width:'100%', marginTop:10}} component="span" onClick={()=>deleteRole()}>
                          {"Delete"}
                        </Button>
                      </Tooltip>
                      </>}
                    </div>
                    }
                  </Grid>
                </Grid>
              </Grid>

              <div style={{ padding: "5px 20px" }}>
                <p className="label2" style={{ marginBottom: 5, marginTop: 7, color: Colors.globalColor8 }}>
                  3. {t("Select Users & Sites")}
                </p>
              </div>
              <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 0, width: "100%", marginBottom: 0 }} />

              <Grid item xs={12} md={12} className="userSitesBox scrollbarShow2" style={{ padding: "0px 10px", maxHeight: "150px", overflowY: "scroll" }}>
                {sitesLoader && <div style={{ display: "flex", justifyContent: "center", textAlign: "center", alignItems: "center", height: "150px" }}>
                      <Spinner />
                    </div>}
                {!sitesLoader && <>
                {newArr.length > 0 ? newArr.map(
                    (item, index) => {
                      return (
                        <>
                          <div style={{ padding: "3px 20px" }}>
                            <div style={{ margin: 0 }}>
                              <Checkbox
                                style={{ color: Colors.globalColor8 }}
                                checked={item.checked}
                                onChange={(e) =>
                                  onCheckUser(e.target.checked, index)
                                }
                              />
                              {item.firstName} {item.lastName}
                            </div>
                          </div>
                          {item.checked && (
                            <div style={{ padding: "0px 20px" }}>
                              {item.sites.length > 0 &&
                                item.sites.map((subItem, subIndex) => {
                                  return (
                                    <div style={{ margin: 0 }}>
                                      <Checkbox
                                        className="sitesCheckbox"
                                        style={{
                                          color: Colors.globalColor8,
                                          marginLeft: "5%",
                                          padding: "3px",
                                        }}
                                        onChange={(e) =>
                                          onCheckSite(
                                            e.target.checked,
                                            index,
                                            subIndex
                                          )
                                        }
                                        checked={subItem.checked}
                                      />
                                      {subItem.title}
                                    </div>
                                  );
                                })}
                            </div>
                          )}
                        </>
                      );
                    }
                  ) : <NoRecords />}
                </>}
              </Grid>
              <Grid item xs={12} md={12} style={{ padding: "0px" }}>
                <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 0, width: "100%", marginBottom: 0 }} />

                <div style={{ padding: "10px 20px" }}>
                  <Button variant="contained" type="submit" className="addBtn" component="span" onClick={addTier}>
                    {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />}
                    {editMode ? <>{t("Update")}</> : <>{t("Add")}</>}
                  </Button>
                  &emsp;
                  <Button variant="contained" type="button" className="cancelBtn" component="span" onClick={cancelEdit} style={{ backgroundColor: "#dadada" }}>
                      {t("Cancel")}
                    </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={12} lg={6}>
            <Grid className="shadow" container alignItems="center" style={{ padding: 0, borderWidth: "1px", borderStyle: "solid", borderColor: Colors.globalColor4, borderRadius: "10px", backgroundColor: "white" }}>
              <Grid item xs={12} md={12} lg={12} style={{ padding: "5px 20px 0px  20px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Colors.globalColor4, display:'flex', alignItems:'center' }}>
                <p className="label2" style={{ marginBottom: 7, marginTop: 7, color: Colors.globalColor8 }}>
                  {t("Workflow Hierarchy")}
                </p>
                <Tooltip title={t("Help")} >
               
                <a href="https://www.uraudits.com/knowledge-center/workflow/" target="blank" style={{color:Colors.globalColor8}}>
                <img src={language == "ar" ? helpAr : help} height={25} style={{marginLeft:'5px'}}/>
                  </a>
                
              </Tooltip>
              </Grid>

              <Grid className="scrollbarShow2" item xs={12} md={12} style={{ height: "430px", overflow: "scroll" }}>
                <div style={{ padding: "10px 20px" }}>
                  {hierarchyLoader && <div style={{ display: "flex", justifyContent: "center", textAlign: "center", alignItems: "center", height: "280px" }}>
                      <Spinner />
                    </div>}
                  {!hierarchyLoader && <>
                      {change ? <HierarchyTable editMode={editMode} editTier={editTier} list={usedRoles} update={update} deleteTier={deleteTier} refetchHierarchy={getAllHierarchyOrganizations} /> : <div style={{ display: "flex", justifyContent: "center", textAlign: "center", alignItems: "center", height: "100%" }}>
                          <NoRecords />
                        </div>}
                    </>}
                </div>
              </Grid>
              <Modal modal={modal} closeModal={closeModal} addNewHierarchy={addNewHierarchy} editHierarchy={editHierarchy} editRole={editRole} currentRole={currentRole} />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <br />
      </div>
    </>;
};

const reorder = (list, startIndex, endIndex) => {
  console.log("original List", list);
  // console.log("Reorder startindex",startIndex)
  // console.log("Reorder endindex",endIndex)
  const newList = [...list];
  const [removed] = newList.splice(startIndex, 1);
  newList.splice(endIndex, 0, removed);
  newList.forEach((item, index) => {
    item.position = index + 1;
  });
  console.log("Reorderd List", newList);
  return newList;

  // console.log("Reorder List",list)
  // console.log("Reorder startindex",startIndex)
  // console.log("Reorder endindex",endIndex)
  // const result = Array.from(list);
  // const [removed] = result.splice(startIndex, 1);
  // result.splice(endIndex, 0, removed);
  // console.log("result of Reorder", result);
  // return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,

  ...(isDragging && {
    background: "transparent",
    height: 80, //50
  }),
});
const getListStyle = (isDraggingOver) => ({
  //background: isDraggingOver ? "lightblue" : "white",
  //padding: grid,
});

const HierarchyTable = (props) => {
  const [items, setItems] = React.useState(
    props?.list.sort(function(a, b) {
      return parseInt(a.position) - parseInt(b.position);
    })
  );
  const classes = useStyles();
  useEffect(() => {
    if (props.update) {
      setItems(props.list);
    }
  }, []);
  const onDelete = (id) => {
    props.deleteTier(id);
  };
  const onDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    var reorderItems = await reorder(
      items,
      result.source.index,
      result.destination.index
    );
    // var list = await [...items];
    // // //  alert(JSON.stringify(list[result.destination.index-1]))
    // // //  return
    // // console.log(result.source.index, result.destination.index);
    // var sourcePosition = await list[result.source.index].position;
    // var destinationPosition = await list[result.destination.index].position;
    // list[result.source.index].position = await destinationPosition;
    // list[result.destination.index].position = await sourcePosition;
    // reorderItems = await list;
    // alert(JSON.stringify(reorderItems))

    console.log("reorderd Items", reorderItems);
    await setItems(reorderItems);
    await editItems(reorderItems);
    //await props.onUpdateChecklist(reorderItems,'main')
  };

  function editItems(arr) {
    let localstorage = localStorage.getItem("UserData");

    var data = JSON.parse(localstorage);
    let token = data.token;

    arr.map(async (v, i) => {
      // console.log(v.position, v.hierarchy_organization_id);
      let req = await fetch(
        GlobalApi + "/HierarchyOrganization/change_hierarchy_possition",//!!!!!!the ss is Intentional in this Api
        {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            position: i + 1,
            hierarchy_organization_id: v.hierarchy_organization_id,
          }),
        }
      );

      let reqJson = await req.json();
      // console.log(reqJson);
    });
  }

  return (
    <div style={{ marginTop: 0 }}>
      {
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <RootRef rootRef={provided.innerRef}>
                <List style={getListStyle(snapshot.isDraggingOver)}>
                  {items.length === 0 && <div style={{ display: "flex", justifyContent: "center", textAlign: "center", alignItems: "center", height: "270px" }}>
                      <NoRecords />
                    </div>}
                  {items.length > 0 &&
                    items.map((item, index) => {
                      console.log("item in workflow", item);
                      var marginLeft = window.innerWidth < 996 ? 0 : index * 20;
                      var color = item.color;
                      console.log(
                        item.position,
                        "p______________________p",
                        item.title
                      );
                      return(
                        <div>
                          <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                            {(provided, snapshot) => <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                <div>
                                  <div>
                                   {window.innerWidth > 996 ? <Paper style={{ marginLeft: marginLeft, backgroundColor: color, paddingRight: 25, paddingLeft: 10, paddingTop: 5, paddingBottom: 5, marginTop: 10, marginBottom: 10, width: 300 }} elevation={3}>
                                      <Grid container direction="row" align="center" justify="space-between" alignItems="center">
                                        <Grid item justifyContent="center" alignItems="center">
                                          <img src={drag} height={20} style={{ display: "inline" }} />
                                          &nbsp;
                                          <Tooltip title={item.title ? item.title : " "}>
                                            <p className="hirarchyTitle" style={{ display: "inline" }}>
                                              {item.title.slice(0, 15) + (item.title.length > 15 ? "..." : "")}
                                            </p>
                                          </Tooltip>
                                        </Grid>
                                        <Grid item alignItems="center">
                                          <div className="hirarchyItem" onClick={() => props.editTier(items, index)} style={{ display: "inline-block" }}>
                                            <ListItemIcon>
                                              <EditIcon style={{ color: "white" }} />
                                            </ListItemIcon>
                                          </div>
                                          &nbsp;
                                          <div className="hirarchyItem" style={{ display: "inline-block", padding: 10 }}>
                                            <Tooltip title="delete tier">
                                              <ListItemIcon onClick={() => {
                                                  onDelete(item.HierarchyOrganizations?.id);
                                                }}>
                                                <DeleteIcon style={{ color: "white" }} />
                                              </ListItemIcon>
                                            </Tooltip>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Paper> : <Paper style={{ marginLeft: marginLeft, backgroundColor: color, paddingRight: 25, paddingLeft: 10, paddingTop: 5, paddingBottom: 5, marginTop: 10, marginBottom: 10, width: '100%' }} elevation={3}>
                                      <Grid container direction="row" align="center" justify="space-between" alignItems="center">
                                        <Grid item justifyContent="center" alignItems="center">
                                          <img src={drag} height={20} style={{ display: "inline" }} />
                                          &nbsp;
                                          <Tooltip title={item.title ? item.title : " "}>
                                            <p className="hirarchyTitle" style={{ display: "inline" }}>
                                              {item.title.slice(0, 10) + (item.title.length > 10 ? "..." : "")}
                                            </p>
                                          </Tooltip>
                                        </Grid>
                                        <Grid item alignItems="center">
                                          <div className="hirarchyItem" onClick={() => props.editTier(items, index)} style={{ display: "inline-block" }}>
                                            <ListItemIcon>
                                              <EditIcon style={{ color: "white" }} />
                                            </ListItemIcon>
                                          </div>
                                          &nbsp;
                                          <div className="hirarchyItem" style={{ display: "inline-block", padding: 10 }}>
                                            <Tooltip title="delete tier">
                                              <ListItemIcon onClick={() => {
                                                  onDelete(item.HierarchyOrganizations?.id);
                                                }}>
                                                <DeleteIcon style={{ color: "white" }} />
                                              </ListItemIcon>
                                            </Tooltip>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Paper>}
                                  </div>
                                </div>
                              </div>}
                          </Draggable>
                        </div>);
                        //=============================================//
                    })}
                </List>
                {provided.placeholder}
              </RootRef>
            )}
          </Droppable>
        </DragDropContext>
      }
    </div>
  );
};

export default Hierarchy;

{
  /* <Grid item>
  <Grid
    container
    justify="center"
    align="center"
    alignItems="center"
    style={{
      padding: 5,
    }}
  >
    <Grid item xs={8}>
      <Action
        id={item.hierarchy_organization_id}
        HierarchyAction={
          item.HierarchyOrganizations
            ? item.HierarchyOrganizations[0]?.HierarchyAction
            : []
        }
      />
    </Grid>
  </Grid>
</Grid>; */
}
